import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL
const baseUrl = `${PROGUIDES_WEB_URL}api/v2/`

export const createPaymentMethod = async form => {
  try {
    const url = `${PROGUIDES_WEB_URL}payment/stripe/createPaymentMethod.php`
    const res = await axios({
      method: "POST",
      url,
      data: form,
    })
    return res.data
  } catch (error) {
    return { status: "failure", message: error.message }
  }
}

export const checkoutWithStripe = async form => {
  try {
    const url = `${baseUrl}payments/gateways/stripe/process-cart`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, form, config)
    return res.data
  } catch (error) {
    return { status: "failure", message: error.message }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/payment.api.js